var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { BuildStatus } from '../../../../../enums/build-status';
import { StateTriggersEnum } from '../../../../../enums/workload/state-triggers';
import { FormService } from '../../../../../services/workload/form.service';
import { FormSyncBuilder } from '../../../../../logic/workload/form-sync-builder';
import { TicketInformationService } from '../../../../../services/workload/ticket-information.service';
var FormNewComponent = /** @class */ (function () {
    function FormNewComponent(formSyncBuilder, formService, ticketInformationService) {
        this.formSyncBuilder = formSyncBuilder;
        this.formService = formService;
        this.ticketInformationService = ticketInformationService;
        this.formDataChange = new EventEmitter();
        this.requestId = 0;
        this.readonly = false;
        this.getFormDataSubscription = new Subscription();
        this.viewModel = {
            sectionHeaders: { assignedUser: 'Assign User' },
            formData: { assignedUser: 0 }
        };
    }
    FormNewComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.formService.getFormData(this.requestId, BuildStatus.ReadyToBuild).subscribe(function (rawData) {
                                if (rawData.data) {
                                    _this.viewModel.formData = JSON.parse(rawData.data);
                                }
                            })];
                    case 1:
                        _a.getFormDataSubscription = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormNewComponent.prototype.ngOnDestroy = function () {
        this.getFormDataSubscription.unsubscribe();
    };
    FormNewComponent.prototype.selectedUserChanged = function (selectedUser) {
        this.viewModel.formData.assignedUser = selectedUser.id;
        this.formDataChange.emit(this.buildFormSync(StateTriggersEnum.ReAssignStaff));
    };
    FormNewComponent.prototype.buildFormSync = function (state) {
        return this.formSyncBuilder.build(JSON.stringify(this.viewModel.formData), BuildStatus.ReadyToBuild, this.requestId, state);
    };
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], FormNewComponent.prototype, "formDataChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], FormNewComponent.prototype, "requestId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], FormNewComponent.prototype, "readonly", void 0);
    FormNewComponent = __decorate([
        Component({
            selector: 'form-new',
            template: require('./form-new.component.html'),
            styles: [require('./form-new.component.scss')]
        }),
        __metadata("design:paramtypes", [FormSyncBuilder,
            FormService,
            TicketInformationService])
    ], FormNewComponent);
    return FormNewComponent;
}());
export { FormNewComponent };
//# sourceMappingURL=data:application/json;base64,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